export default __webpack_public_path__ + "static/media/cr5.4ab4de14.jpg";